import { ControllerExtensionModel } from '@/models/ControllerExtensionModel.ts'
import { RemoteControlModel } from '@/models/RemoteControlModel.ts'
import { Product } from '@/services/models/implementations/Product.ts'
import { CharacteristicType } from '@/helper/Types.ts'
import { ControllerExtensionCharacteristic } from '@/services/models/ControllerExtensionCharacteristic.ts'
import { RemoteControlCharacteristic } from '@/services/models/RemoteControlCharacteristic.ts'

type ExtensionPreferences = {
  decouplingBuffer: boolean,
  amountOfCircuits: number,
  remoteControl?: RemoteControlCharacteristic,
  heatPumpCascadeSize: number,
}

class ControllerExtensionPreselection {

  shouldPreselect(controllerExtension: Product, preferences: ExtensionPreferences, amountOfAvailableExtensions: number): boolean {
    const controllerExtensionModel = controllerExtension
      .getProductCharacteristic<ControllerExtensionCharacteristic>(CharacteristicType.CONTROLLER_EXTENSION).model

    if (controllerExtensionModel === ControllerExtensionModel.VR71) {
      if (amountOfAvailableExtensions === 1 && this.shouldPreSelectVR70(preferences)) {
        return true
      }

      return this.shouldPreSelectVR71(preferences)
    }

    return this.shouldPreSelectVR70(preferences)
  }

  private shouldPreSelectVR71(preferences: ExtensionPreferences): boolean {
    if (preferences.heatPumpCascadeSize > 1) {
      return true
    }

    if (preferences.amountOfCircuits > 2) {
      return true
    }

    return preferences.remoteControl?.model === RemoteControlModel.VR92
  }

  private shouldPreSelectVR70(preferences: ExtensionPreferences): boolean {
    if (preferences.heatPumpCascadeSize > 1) {
      return false
    }

    if (preferences.amountOfCircuits > 2) {
      return false
    }

    if (preferences.remoteControl?.model === RemoteControlModel.VR92) {
      return false
    }

    if (preferences.decouplingBuffer) {
      return true
    }

    if (preferences.amountOfCircuits === 2) {
      return true
    }

    return preferences.remoteControl !== undefined
  }
}

export const controllerExtensionPreselection = new ControllerExtensionPreselection()
